import {combineReducers} from '@reduxjs/toolkit';
import accountReducer from './slices/accountSlice';
import screenReducer from './slices/screenSlice';
import settingsReducer from './slices/settingsSlice';

const baseReducer = combineReducers({
  screen: screenReducer,
  account: accountReducer,
  settings: settingsReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === 'auth/onLogout') {
    state.screen = undefined;
    state.account = undefined;
  }

  return baseReducer(state, action);
};
